import axios from 'axios'
import log from 'loglevel'
import { siteTierConfig } from '../App/App.config'

const router = async (type, payload, credentials = {}) => {
  const routerPayload = {
    type,
    payload,
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(credentials.token && { Authorization: `Bearer ${credentials.token}` }),
  }

  try {
    log.debug(`[CM] Router ${type} Request`, routerPayload)
    const res = await axios.post(
      siteTierConfig.routerLambdaUrl,
      routerPayload,
      { headers },
    )
    log.debug(`[CM] Router ${type} Response:`, res.data)

    if (Array.isArray(res.data.errors)) {
      const details = res.data.errors
        .map((e) => `${e.code}: ${e.detail}`)
        .join('\n')
      const message =
        details || `Unhandled ${res.status} Error: ${JSON.stringify(res.data)}`
      log.error(message)
      // throw new Error(message)
    }
    return res.data
  } catch (error) {
    log.error(`[CM] Unhandled Router ${type} Service Error`, error)
    throw error
  }
}

export default router
